<div class="custom-field-display-columns--content">
  <ng-container
    *ngFor="let field of customFieldValues; index as i; trackBy: trackById"
  >
    <div class="row" *ngIf="i % 4 === 0">
      <ng-container
        *ngFor="
          let subField of customFieldValues.slice(i, i + 4);
          trackBy: trackById
        "
      >
        <div class="col-md-3 mb-4">
          <div class="lum-label">{{ subField.custom_field.label }}</div>
          <div class="text-medium">{{ subField | customFieldParseValue }}</div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
